<template>
	<InfoPill>
		<div class="flex items-center gap-2">
			<InfoCircle class="size-5 shrink-0"></InfoCircle>
			<div>{{ props.message.messageText }}</div>
		</div>
	</InfoPill>
</template>

<script setup lang="ts">
import type { Props } from '@/types/Message'
const props = defineProps<Props>()

import InfoPill from '../InfoPill.vue'
import InfoCircle from '@/assets/icons/info-circle.svg'
</script>

<style scoped></style>
